import { SvgIcon } from '@farewill/ui'
import { SvgIconProps } from '@farewill/ui/components/Icon/types'

export const CopyToClipboardIcon = ({
  className,
  ...rest
}: {
  className?: string
} & SvgIconProps) => (
  <SvgIcon className={className} {...rest}>
    <g fillRule="evenodd" stroke="none" strokeWidth="1">
      <path
        d="M14,0 L2,0 C0.9,0 0,0.9 0,2 L0,16 L2,16 L2,2 L14,2 L14,0 L14,0 Z M17,4 L6,4 C4.9,4 4,4.9 4,6 L4,20 C4,21.1 4.9,22 6,22 L17,22 C18.1,22 19,21.1 19,20 L19,6 C19,4.9 18.1,4 17,4 L17,4 Z M17,20 L6,20 L6,6 L17,6 L17,20 L17,20 Z"
        id="Shape"
      />
    </g>
  </SvgIcon>
)

export const UploadIcon = ({ color }: { color: string }) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill={color}
    viewBox="0 0 24 24"
  >
    <path
      fill={color}
      d="M4 13a1 1 0 1 1 2 0v5h12v-5a1 1 0 1 1 2 0v6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zm3.293-4.293a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0l4 4a1 1 0 1 1-1.414 1.414L13 6.414V14.5a1 1 0 1 1-2 0V6.414L8.707 8.707a1 1 0 0 1-1.414 0"
    />
  </SvgIcon>
)

export const DocumentIcon = ({ color }: { color: string }) => {
  return (
    <SvgIcon viewBox="0 0 16 16" width={16} height={16}>
      <path
        d="M4.00033 14.6668C3.63366 14.6668 3.31977 14.5363 3.05866 14.2752C2.79755 14.0141 2.66699 13.7002 2.66699 13.3335V2.66683C2.66699 2.30016 2.79755 1.98627 3.05866 1.72516C3.31977 1.46405 3.63366 1.3335 4.00033 1.3335H9.33366L13.3337 5.3335V13.3335C13.3337 13.7002 13.2031 14.0141 12.942 14.2752C12.6809 14.5363 12.367 14.6668 12.0003 14.6668H4.00033ZM8.66699 6.00016V2.66683H4.00033V13.3335H12.0003V6.00016H8.66699Z"
        fill={color}
      />
    </SvgIcon>
  )
}
